import { ParentTypes } from '@risksmart-app/domain/src/types/consts';
import i18n from '@risksmart-app/i18n/src/i18n';
import { t } from 'i18next';

import { getAuditColumns } from './shared';
import type { SharedDataset } from './types';

export const getEnterpriseRisks = () =>
  ({
    hasAccess: (isModuleEnabled, isFeatureFlagEnabled) =>
      isFeatureFlagEnabled('cds_enterprise_risk') &&
      isModuleEnabled('enterprise_risk'),
    objectType: ParentTypes.EnterpriseRisk,
    label: i18n.format(t('enterprise_risk_other'), 'capitalize'),
    datasetRelationshipOverrides: {
      enterpriseRisks: ['parent', 'child'],
    },
    customAttributeFormConfigurationParentTypes: [ParentTypes.Risk],
    fields: {
      id: {
        dataType: 'guid',
        displayType: 'text',
        defaultLabel: t('columns.guid'),
      },
      sequentialId: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('columns.id'),
        prefix: 'ER-',
      },
      title: {
        dataType: 'text',
        displayType: 'text',
        defaultLabel: t('enterpriseRisks.fields.title'),
      },
      description: {
        dataType: 'text',
        displayType: 'text',
        defaultLabel: t('enterpriseRisks.fields.description'),
      },
      tier: {
        dataType: 'number',
        displayType: 'commonLookup',
        i18nKey: 'tiers',
        defaultLabel: t('enterpriseRisks.fields.tier'),
      },
      treatment: {
        dataType: 'text',
        displayType: 'commonLookup',
        i18nKey: 'treatments',
        defaultLabel: t('enterpriseRisks.fields.treatment'),
      },
      inherentScoreMean: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('enterpriseRisks.columns.inherentScoreMean'),
      },
      inherentScoreWorstCase: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('enterpriseRisks.columns.inherentScoreWorstCase'),
      },
      residualScoreMean: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('enterpriseRisks.columns.residualScoreMean'),
      },
      residualScoreWorstCase: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('enterpriseRisks.columns.residualScoreWorstCase'),
      },
      inherentRatingMean: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('enterpriseRisks.columns.inherentRatingMean'),
      },
      inherentRatingWorstCase: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('enterpriseRisks.columns.inherentRatingWorstCase'),
      },
      residualRatingMean: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('enterpriseRisks.columns.residualRatingMean'),
      },
      residualRatingWorstCase: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('enterpriseRisks.columns.residualRatingWorstCase'),
      },
      ...getAuditColumns(),
    },
  }) as const satisfies SharedDataset;
